module.exports = __webpack_public_path__ + "static/img/161_phase_function_Paper_PointsHejduk_Prediction.85ab8b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/161_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 5eCe
// module chunks = 0